import { getImageSrc } from '../utils/imageAssets';

function OptimizedImage({
  image,
  alt = '',
  className,
  loading,
  decoding = 'async',
  fetchPriority,
  width,
  height,
}) {
  const webp = typeof image === 'string' ? image : image.webp;
  const fallback = getImageSrc(image);

  return (
    <picture>
      {typeof image !== 'string' && (
        <source srcSet={webp} type="image/webp" />
      )}
      <img
        src={fallback}
        alt={alt}
        className={className}
        loading={loading}
        decoding={decoding}
        fetchPriority={fetchPriority}
        width={width}
        height={height}
      />
    </picture>
  );
}

export default OptimizedImage;
